/**
 * Tiny form helpers: render a labelled <input>, attach submit handling, and
 * provide a single error/status zone so individual pages don't reinvent it.
 */

export function escape(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function field({ name, label, type = 'text', value = '', autocomplete, required = true, placeholder = '' }) {
  return `
    <label class="field">
      <span class="field-label">${escape(label)}</span>
      <input
        class="field-input"
        name="${escape(name)}"
        type="${escape(type)}"
        value="${escape(value)}"
        ${autocomplete ? `autocomplete="${escape(autocomplete)}"` : ''}
        ${required ? 'required' : ''}
        placeholder="${escape(placeholder)}"
      />
    </label>
  `;
}

export function statusZone(id = 'form-status') {
  return `<div class="form-status" id="${escape(id)}" role="status" aria-live="polite"></div>`;
}

export function setStatus(id, { message, kind = 'info' } = {}) {
  const el = document.getElementById(id);
  if (!el) return;
  if (!message) {
    el.innerHTML = '';
    el.dataset.kind = '';
    return;
  }
  el.dataset.kind = kind;
  el.innerHTML = `<span class="form-status-text">${escape(message)}</span>`;
}

export function bindSubmit(form, handler) {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const submit = form.querySelector('button[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const data = Object.fromEntries(new FormData(form).entries());
      await handler(data, form);
    } finally {
      if (submit) submit.disabled = false;
    }
  });
}
